import { useQuery } from 'react-query';
import { getPartitionArchiveOverview } from '~/api/partitionArchive';

export const usePartitionArchiveOverview = (enabled?: boolean) =>
  useQuery('partitionArchiveOverview', getPartitionArchiveOverview, { enabled });
